import facebook from '~/services/facebook.pixel';
import tiktok from '~/services/tiktok.pixel';
import twitter from '~/services/twitter.pixel';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  userId: string;
};

class CompleteRegistrationEvent extends UserEvent<EventData> {
  sendToFacebook() {
    return facebook.fireCustomEvent('CompleteRegistration');
  }

  sendToTikTok() {
    return tiktok.fireEvent('CompleteRegistration');
  }

  sendToTwitter() {
    return twitter.fireEvent(twitter.EventIds.CompleteRegistration);
  }
}

export default CompleteRegistrationEvent;
